import { ORDER_VOLUME_TYPE } from 'entities/orders/lib/constants'

// Основная функция расчета маржи
export const calculateMargin = (orders, leverage, symbols) => {
  let totalOrderValue = 0

  // console.log(orders, leverage, symbols)

  orders.forEach(order => {
    const { volume, open_price, volume_type, symbol } = order

    const orderSymbolType = symbols?.[symbol]?.type

    const leverageValue = leverage?.[orderSymbolType]?.leverage_value || 1
    const lotSize = leverage?.[orderSymbolType]?.lot_size || 100000

    let orderVolume = volume

    const marginCalculators = {
      forex: () => {
        if (
          volume_type === ORDER_VOLUME_TYPE.LOTS ||
          volume_type === ORDER_VOLUME_TYPE.UNIT
        ) {
          const volumeInUnits = volume * lotSize

          // return (volumeInUnits / leverageValue) * open_price

          return volumeInUnits / leverageValue
        }
        if (volume_type === ORDER_VOLUME_TYPE.CURRENCY) {
          return volume / leverageValue
        }
        throw new Error('Invalid volume type for forex')
      },
      crypto: () => {
        if (
          volume_type === ORDER_VOLUME_TYPE.LOTS ||
          volume_type === ORDER_VOLUME_TYPE.UNIT
        ) {
          return (volume * open_price) / leverageValue
        }
        if (volume_type === ORDER_VOLUME_TYPE.CURRENCY) {
          return volume / leverageValue
        }
        throw new Error('Invalid volume type for crypto')
      },
      stocks: () => {
        if (
          volume_type === ORDER_VOLUME_TYPE.LOTS ||
          volume_type === ORDER_VOLUME_TYPE.UNIT
        ) {
          return (volume * open_price) / leverageValue
        }
        if (volume_type === ORDER_VOLUME_TYPE.CURRENCY) {
          return volume / leverageValue
        }
        throw new Error('Invalid volume type for stocks')
      },
      commodities: () => {
        if (
          volume_type === ORDER_VOLUME_TYPE.LOTS ||
          volume_type === ORDER_VOLUME_TYPE.UNIT
        ) {
          const volumeInUnits = volume * lotSize
          return (volumeInUnits / leverageValue) * open_price
        }
        if (volume_type === ORDER_VOLUME_TYPE.CURRENCY) {
          return volume / leverageValue
        }
        throw new Error('Invalid volume type for commodities')
      },
      metals: () => {
        if (
          volume_type === ORDER_VOLUME_TYPE.LOTS ||
          volume_type === ORDER_VOLUME_TYPE.UNIT
        ) {
          const volumeInUnits = volume * lotSize
          return (volumeInUnits / leverageValue) * open_price
        }
        if (volume_type === ORDER_VOLUME_TYPE.CURRENCY) {
          return volume / leverageValue
        }
        throw new Error('Invalid volume type for metals')
      },
      indices: () => {
        if (
          volume_type === ORDER_VOLUME_TYPE.LOTS ||
          volume_type === ORDER_VOLUME_TYPE.UNIT
        ) {
          const volumeInUnits = volume * lotSize
          return (volumeInUnits / leverageValue) * open_price
        }
        if (volume_type === ORDER_VOLUME_TYPE.CURRENCY) {
          return volume / leverageValue
        }
        throw new Error('Invalid volume type for indices')
      },
      default: () => {
        return 0
      },
    }

    const margin = (
      marginCalculators[orderSymbolType] || marginCalculators.default
    )()

    totalOrderValue += margin
  })

  return totalOrderValue
}
